export default __webpack_public_path__ + "static/media/glass-bead-blasting-icon-dark.a0e41876.svg";